import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_TDS);
var axios_instance_bulk = get_axios_instance(api_variables.SERVICE_TDS_BULK_UPLOAD);


const state = {
    data: [],
    tds: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false
};

const mutations = {
    set: (state, payload) => {
        state.data = payload;
    },

    setTds: (state, payload) => {
        if (payload) {
            state.tds = payload;
        }
    },

    addEmployee: (state, payload) => {
        state.tds = payload;
        // state.data.push(payload);
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },
}

const actions = {
    async fetchAll({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance.get(`/`);
            commit("setFetching", false);
            if (res.status == 200) {
                commit("set", payload);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async fetchTds({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance.get(`/`, {
                params: {
                    paygroupId: payload
                }
            });
            commit("setFetching", false);
            if (res.status == 200) {
                commit("setTds", res.data.rows);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async create({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.post('/', payload);
            commit("setSaving", false);
            if (res.status == 200) {
                commit("addEmployee", payload);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async update({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.put(`/${payload.id}`, payload);
            commit("setSaving", false);
            if (res.status == 200) {
                commit("updateEmployeeById", res.data);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async delete({ commit }, payload) {
        try {
            commit("setDeleting", true);
            let res = await axios_instance.delete(`/${payload.id}`);
            commit("setDeleting", false);
            if (res.status == 200) {
                commit("removeEmployeeById", payload.id);
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async act_upload({commit},payload){
        try{
            commit("setSaving",true);
            let res = await axios_instance_bulk.post('',payload);
            commit("setSaving",false);
            if(res.status==200){
                return res;
            }
            
        }catch(err){
            throw errorHandler(err.response);
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}